































import { Component, Prop, Vue } from 'vue-property-decorator'
import HdsBtn, { HADES_BTN_SIZE } from '@/components/HdsBtn.vue'
import HdsIcon from '@/components/HdsIcon.vue'

/**
 * 서버의 메세지 등을 출력해주는 컴포넌트입니다.
 */
@Component({
  components: { HdsIcon, HdsBtn },
})
export default class HdsSnackbar extends Vue {
  name: string = 'HdsSnackbar.vue'

  HADES_BTN_SIZE = HADES_BTN_SIZE

  /**
   * 컴포넌트가 위치할 위치입니다.
   */
  @Prop({
    type: String,
    default: 'center',
  })
  align!: string

  /**
   * 컴포넌트의 z-index 입니다.
   */
  @Prop({
    type: Number,
    default: 10,
  })
  zIndex!: number

  /**
   * Fixed(true) or Absolute(false)
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  fixed!: boolean

  /**
   * 버튼 텍스트 입니다.
   */
  @Prop({
    type: String,
  })
  btnText?: string

  /**
   *  닫기 아이콘 유무입니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  close!: boolean

  /**
   *  닫기 아이콘 mdi입니다.
   */
  @Prop({
    type: String,
    default: 'close-circle',
  })
  closeIcon!: string

  /**
   * 상하좌우 여백을 줄입니다.
   */
  @Prop({
    type: Boolean,
    default: false,
  })
  dense!: boolean

  /**
   * 버튼 색 입니다.
   */
  @Prop({
    type: String,
    default: 'whitesmoke',
  })
  btnColor!: string

  /**
   * 컨테이너 배경 색 입니다.
   */
  @Prop({
    type: String,
  })
  background?: string

  get containerClasses() {
    return {
      'hds-container': true,
      [`hds-snackbar--${this.align}`]: !!this.align,
      'hds-snackbar--fixed': this.fixed,
    }
  }

  get snackbarClasses() {
    return {
      'hds-snackbar': true,
      'hds-snackbar--dense': this.dense,
    }
  }

  get messageClasses() {
    return {
      'hds-message': true,
    }
  }

  get btnClasses() {
    return {
      'hds-btn': true,
    }
  }

  get snackbarStyles() {
    return {
      'z-index': this.zIndex,
      background: this.background,
    }
  }

  get btnStyles() {
    return {}
  }

  clickBtn() {
    this.$emit('click')
  }

  clickClose() {
    this.$emit('click:close')
  }
}
